import styled from 'styled-components';

import {AnchorLink} from '../../ui-toolkit/elements/button/btn-type/AnchorLink';

import {
    CheckboxDropdownWrapper,
    DropdownBtn,
} from '../../ui-toolkit/custom-feature/checkbox-dropdown/CheckboxDropdownStructure';
import {Badge} from '../../ui-toolkit/elements/badge/Badge';
import {btnColorSetup} from '../../ui-toolkit/elements/button/btn-setup/btnStyling';
import {Btn} from '../../ui-toolkit/elements/button/btn-type/Btn';
import {Card} from '../../ui-toolkit/elements/card-v2/Card';
import {Grid} from '../../ui-toolkit/page/grid/Grid.tsx';
import {GridItem} from '../../ui-toolkit/page/grid/GridItems.tsx';

const EntityListHeader = styled.div`
    grid-area: entityListHeader;
    width: 100%;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    margin-bottom: var(--space-sm);
    align-items: center;
    min-height: 38px;
`;
const EntityListLeft = styled.div`
    ${Card.Wrapper} {
        margin-bottom: 0 !important;
    }
`;
const EntityListRight = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 4px;
    padding: 4px 0;

    > ${Btn} {
        margin: 0;
    }
    ${CheckboxDropdownWrapper} {
        ${DropdownBtn} {
            margin-bottom: 0 !important;
            ${btnColorSetup({
                border: 'var(--primary)',
                txt: 'var(--primary)',
                background: 'var(--app-background)',
            })};

            &:hover {
                ${btnColorSetup({
                    background: 'var(--container-background-hover-color-300)',
                    border: 'var(--primary-dark)',
                    txt: 'var(--primary-dark)',
                })};
            }
        }
    }
`;

const EntityFilterBtn = styled(Btn)`
    ${Badge.Container} {
        height: 14px;
        width: 14px;
        border-radius: 50%;
        position: relative;
        padding: 0;
        margin: 0;
        span {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: var(--text-size-x-small);
        }
    }
`;

EntityListHeader.Left = EntityListLeft;
EntityListHeader.Right = EntityListRight;
EntityListHeader.FilterBtn = EntityFilterBtn;

export {EntityFilterBtn, EntityListHeader, EntityListLeft, EntityListRight};

export const EntityListGrid = styled(Grid).attrs(() => ({
    areas: ['header', 'main'],
    rows: 'auto 1fr',
    overflow: 'hidden',
    gap: 'var(--space)',
}))`
    height: 100%;
    ${AnchorLink} {
        line-height: 0;
    }
`;

export const EntityContainerTab = styled.div`
    ${Card.Wrapper} {
        margin-bottom: 0;
    }
`;

export const EntityTableHeader = styled(GridItem.Flex).attrs(() => ({
    justify: 'space-between',
    gap: 'var(--space)',
    align: 'center',
    area: 'header',
}))`
    @media only screen and (max-width: 1024px) {
        flex-direction: column;
        align-items: flex-start;
        > div {
            justify-content: flex-start;
        }
    }

    ${CheckboxDropdownWrapper} {
        ${DropdownBtn} {
            margin-bottom: 0 !important;
            ${btnColorSetup({
                border: 'var(--primary)',
                txt: 'var(--primary)',
                background: 'var(--app-background)',
            })};

            &:hover {
                ${btnColorSetup({
                    background: 'var(--container-background-hover-color-300)',
                    border: 'var(--primary-dark)',
                    txt: 'var(--primary-dark)',
                })};
            }
        }
    }
`;
